import React, { useState, useEffect } from "react";
import axios from "axios";
import Carousel from "react-elastic-carousel";
import { Link } from "react-router-dom";

const Home = () => {
  const [homeMovies, setHomeMovies] = useState([]);

  const breakPoints = [
    { width: 1, itemsToShow: 1, pagination: false },
    { width: 550, itemsToShow: 2, pagination: false },
    { width: 768, itemsToShow: 3, pagination: false },
    { width: 1200, itemsToShow: 4, pagination: false },
  ];

  useEffect(() => {
    axios
      .get(
        "https://api.themoviedb.org/3/movie/popular?api_key=864351c4983b669ad95578b475142944&language=en-US&page=1"
      )
      .then((res) => {
        setHomeMovies(res.data.results);
        console.log(res.data.results);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <div className="" id="home-wrap">
      <div className="" id="carousel">
        <Carousel
          id=""
          breakPoints={breakPoints}
          enableAutoPlay
          className=""
          
        >
          {homeMovies.map((home) => (
            <div key={home.id} className="">
              <Link to={"/" + home.id} id="link-wrap">
                <img
                  className="img-fluid px-1 home-image"
                  src={
                    "https://image.tmdb.org/t/p/original/" + home.poster_path
                  }
                  alt={home.title}
                />
              </Link>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Home;
